// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fDoJ","right":"styles_right__1TFzM"};